import type { EntityIndexedDBEntry } from '../../state/entities-indexed-db/entities-indexed-db';

/**
 * Filters entity entries to only those that are pending import (status is 'ready' or 'error').
 * These are the entities that have not been successfully imported or skipped.
 *
 * @param entities - Array of entity entries from IndexedDB (or undefined while loading)
 * @returns Filtered array of entities that still need to be imported
 */
export const filterEntitiesToImport = (
  entities: EntityIndexedDBEntry[] | undefined,
): EntityIndexedDBEntry[] =>
  entities?.filter(
    (entity) => entity.status !== 'complete' && entity.status !== 'skipped',
  ) ?? [];
